import React from 'react'

export function UnlockedContent({ children }) {
  return <div className="content">{children}</div>
}
